import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { ReelsCreatorSubpageFrame } from './ReelsCreatorSubpageFrame';

/** The settings page's frame; the page scrolls inside it. */
export const ReelsCreatorSettingsFrame = ({ children }: { children: ReactNode }) => {
  const { t } = useTranslation('reelsCreator');
  return (
    <ReelsCreatorSubpageFrame
      title={t('reelsCreatorSettingsPage.title')}
      testId="reels-creator-settings"
      bodyClassName="overflow-auto"
    >
      {children}
    </ReelsCreatorSubpageFrame>
  );
};
